<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box" v-if="ay_std_div_list!=null">
            <v-toolbar class="toolbar" flat dense>
                <v-toolbar-title>
                    <strong>
                      Configure  Brunch Amount
                    </strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-row justify="center" dense>
                <v-col sm="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="sel_ay_data" return-object :items="ay_std_div_list" item-text="ay" label="Academic Year" outlined @change="getStd();" 
                    persistent-hint hint="Please Select Academic Year"
                    />
                </v-col>
                <v-col sm="2" v-if="std_div_list!=null">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="sel_std_data" return-object :items="std_div_list" item-text="std" label="Standard" outlined  
                    persistent-hint hint="Please Select Standard"
                    
                    />
                </v-col>
                <v-col  sm="2" v-if="sel_std_data" class="pt-5">
                    <v-btn class="button" @click="configureBrunchAmount()">Proceed</v-btn>
                </v-col>
            </v-row>
            <v-col cols="12" sm="12" md="12" v-if="brunch_list!=''" >
            <!-- {{brunch_list}} -->
            <v-row class="toolbar" dense justify="center" >
                <v-col cols="12" sm="3" md="3">
                   <center>Brunch</center>
                </v-col>
                <v-col cols="12" sm="3" md="3">
                   <center> Installment</center>
                </v-col>
                 <v-col v-for="quota in quotalist" :key="quota" cols="12" sm="3" md="3">
                  <center>  Amount ({{quota.quota}}) </center>
                </v-col>
                
            </v-row>
             <v-row dense justify="center" v-for="brunch in brunch_list" :key="brunch.id">
                <v-col class="p-0 m-0" cols="12" sm="3" md="3">
                   <center> {{brunch.name}}</center>
                </v-col>
                <v-col class="p-0 m-0" cols="12" sm="3" md="3">
                   <center> {{brunch.installment}}</center>
                </v-col>
                <v-col class="p-0 m-0" v-for="quota in quotalist" :key="quota" cols="12" sm="3" md="3">
                  <center> <v-text-field type="number" v-model="brunch.quota_amount" color="#0F2027" dense outlined rounded></v-text-field></center>
                </v-col>
             </v-row>
             <v-row dense justify="center">
             <v-btn class="button" @click=" saveBrunchAmount(brunch_list)">Add Amount</v-btn>
             </v-row>
            </v-col>
        </v-card>
    </div>
</template>
<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    export default {
        data() {
            return {
                selected: [],
                snackbar: false,
                snackbar_msg: "",
                color: "",
                snackbar: false,
                ay_std_div_list: null,
                sel_ay_data: null,
                show_tt: false,
                std_div_list: null,
                sel_std_data: null,
                brunch_list:[],
                quotalist:[],
                amt_general:null,
            };
        },
        methods: {
             showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            saveBrunchAmount(brunchlist){
            const data = {
                    brunchlist:brunchlist
                 }
                axios
                 .post("/AccountingAndFees/saveBrunchAmount",data)
                    .then((res) => {
                       if (res.data.flag == "YES") {
                        this.showSnackbar("#4caf50", "Brunch Amount Set Successfully..."); // show snackbar on success
                        this.configureBrunchAmount()
                    } 
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    })
                    .finally(() => {});
            },
             getStd() {
                this.std_div_list = null;
                this.sel_std_data = null;
                this.std_div_list = this.sel_ay_data.std_list;
            },
            configureBrunchAmount(){
                 const data = {
                    ay : this.sel_ay_data.ay_id,
                    standard:this.sel_std_data.std_id,
                 }
                axios
                 .post("/AccountingAndFees/configureBrunchAmount",data)
                    .then((res) => {
                        this.brunch_list = res.data.brunch_list
                        this.quotalist = res.data.quotalist
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    })
                    .finally(() => {});
            },
            onload() {
                axios
                    .post("/commonAPI/get_ay_std_div")
                    .then((res) => {
                        this.ay_std_div_list = res.data.data;
                        this.sel_ay_data = res.data.curr_ay;
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    })
                    .finally(() => {});
            },
        },
        mounted() {
            this.onload();
        },
    };
</script>
<style scoped>
    .radiospace {
        margin: 1rem !important;
        padding: 0%;
    }
    .btn-css {
        outline: 0 !important;
        outline-offset: 0 !important;
        background-image: none !important;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        background-color: #fff !important;
        text-decoration: underline;
        color: #0f2027 !important;
        text-align: left;
    }

    .btn-css:hover {
        outline: 0 !important;
        outline-offset: 0 !important;
        background-image: none !important;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        background-color: #ffff !important;
        color: #0f2027 !important;
        text-decoration: underline;
        text-align: left;
    }
    .t-row {
        padding: 1rem i !important;
    }
    .mytable /deep/ thead th {
        background: #0f2027 !important; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
    .delete-avatar {
        transition: 0.3s;
        border: 1px solid red;
        margin: 0.2rem !important;
    }
    .delete-avatar:hover {
        background-color: transparent;
    }
    .delete-v-icon {
        padding-left: 8px;
        padding-top: 1px;
        font-size: 15px;
    }
    .delete-v-icon:hover {
        color: white;
    }
</style>
